<template>
  <v-card>
    <v-container class="teal" fluid>
      <filter-header
        v-model="filters"
        @validated="filtersValidated"
        single-device
      />
      <v-btn
        @click="updateData"
        :loading="loading"
        :disabled="!valid"
        color="teal lighten-1"
        elevation="6"
        large
      >
        データ更新
        <v-icon right color="white">mdi-import</v-icon>
      </v-btn>
    </v-container>
    <v-container fluid>
      <heatmap-chart ref="chart" :loading="loading" />
    </v-container>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import FilterHeader from '@/components/report/FilterHeader'
import HeatmapChart from '@/components/report/HeatmapChart'

export default {
  name: 'EyeTrackingDashboard',
  components: {
    HeatmapChart,
    FilterHeader
  },
  data: () => ({
    loading: false,
    valid: false,
    filters: {}
  }),
  methods: {
    ...mapActions({
      showSnack: 'snackbar/showSnack'
    }),
    filtersValidated(valid) {
      this.valid = valid
    },
    async updateData() {
      if (this.valid) {
        const startDate = new Date(this.filters.date.start)
        const endDate = new Date(this.filters.date.end)

        this.loading = true
        await this.$refs.chart.updateChart(
          this.filters.devices,
          startDate,
          endDate
        )
        this.loading = false
      }
    },
    showError(message) {
      this.showSnack({ message: `失敗しました: ${message}`, color: 'error' })
    }
  }
}
</script>
<style scoped></style>
